var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        [
          _c("PostContent", {
            attrs: { post: _vm.post, "is-disp-title": false },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block mt-6" },
            [
              _c("h3", { staticClass: "title is-4" }, [
                _vm._v(_vm._s(_vm.$t("term.explanation"))),
              ]),
              _vm._v(" "),
              _vm.post.answerExplanation
                ? _c("html-content", {
                    staticClass: "column",
                    attrs: { body: _vm.post.answerExplanationHtml },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("EbImages", {
                attrs: {
                  images: _vm.post.answerExpImages,
                  "target-service-id": _vm.postServiceId,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "nav",
            {
              staticClass: "breadcrumb",
              attrs: { "aria-label": "breadcrumbs" },
            },
            [
              "category" in _vm.post && _vm.post.category
                ? _c(
                    "ul",
                    [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: `/posts/${_vm.postServiceId}/` } },
                            [_vm._v(_vm._s(_vm.$t("common.posts")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.post.category.parents, function (parent) {
                        return _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/posts/${_vm.postServiceId}/categories/${parent.slug}`,
                                },
                              },
                              [_vm._v(_vm._s(parent.label))]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: `/posts/${_vm.postServiceId}/categories/${_vm.post.category.slug}`,
                              },
                            },
                            [_vm._v(_vm._s(_vm.post.category.label))]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          "tags" in _vm.post && _vm.post.tags
            ? _c(
                "ul",
                _vm._l(_vm.post.tags, function (tag) {
                  return _c(
                    "li",
                    { staticClass: "is-inline-block mr-2" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "tag",
                          attrs: {
                            to: `/posts/${_vm.postServiceId}/tags/${tag.label}`,
                          },
                        },
                        [_vm._v(_vm._s(tag.label))]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }